import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { PrivateAreaRoutingModule } from "./private-area-routing.module";
import { PrivateAreaComponent } from "./private-area.component";

@NgModule({
  declarations: [
    PrivateAreaComponent
  ],
  imports: [
    CommonModule,
    PrivateAreaRoutingModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule
  ]
})
export class PrivateAreaModule {
  static forRoot(): ModuleWithProviders<PrivateAreaModule> {
    return {
      ngModule: PrivateAreaModule
    };
  }
}
